export const featureFlagConstants = {
  GET_FEATURE_FLAGS_INIT: 'GET_FEATURE_FLAGS_INIT',
  GET_FEATURE_FLAGS_SUCCESS: 'GET_FEATURE_FLAGS_SUCCESS',
}
